<template>
  <div class="template">
    <div class="title-area"
      :style="{ backgroundImage: `url(${banner.img == undefined?'': domain + banner.img})` }"
    >
      <div class="wrap">
        <div class="top-wrap">
          <div class="title">{{banner.title}}</div>
          <span class="english-title">
            {{banner.desc}}
          </span>
        </div>
      </div>
    </div>
    <div class="news-content wrap">
      <div class="tabs-list">
        <div
          class="tab-item"
          v-for="(item, idx) in tabs"
          :key="idx"
          @click="handleTab(idx, item.id)"
          :class="currentTab == idx ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="news-list">
        <div
          class="news-item"
          v-for="(item, idx) in newList"
          :key="idx"
          @click="goPage(item.id)"
        >
          <div class="news-img">
            <img :src="domain+item.img" alt="" />
          </div>
          <div class="news-info">
            <div class="news-title">
              {{ item.title }}
            </div>
            <div class="news-detail">
              {{ item.desc }}
            </div>
            <div class="time">{{ item.create_time }}</div>
            <div class="more">
              查看详情
              <img src="../../assets/img/icon/icon_xl@2x.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="pages">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import { newsCategory, newsList,banner } from "../../network/http_api";
import { BASEDOMAIN } from "../../common/config";

export default {
  data() {
    return {
      banner:'',
      domain:'',
      tabId: "",
      page:1,
      pageSize:10,
      total:0,
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      currentTab: 0,
      tabs: ["全部456", "公司新闻", "行业动态"],
      newList: []
    };
  },
  created() {
    this.domain = BASEDOMAIN
    //console.log("newsCategory");
    let cls = window.sessionStorage.getItem('cls')
    if(cls == '' || cls == undefined){
      this.currentTab = 0
      this.tabId = ''
    }else {
      this.currentTab = cls
      this.tabId = cls

    }
    this.getData();
    this.getList();
    this.getBanner()
      //  console.log("clsres");

  },
  methods: {
    async getBanner() {
      let res = await banner(4);
      if (res.code == 200) {
        this.banner = res.data[0];
        //console.log("banner", res.data);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
    async getList() {
      let res = await newsList(this.tabId,this.page,this.pageSize);
        if (res.code == 200) {
        this.newList = res.data.data;
        this.total = res.data.total
      } else {
        this.$message.error(res.msg);
      }
      //console.log("list", res);
    },
    async getData() {
      let res = await newsCategory();
      if (res.code == 200) {
        this.tabs = res.data;
        this.tabs.unshift({
          id: '',
          name: "全部",
        });
        //console.log("footres", res);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("newsCategory", res);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
       this.pageSize = val;
       this.getData()
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
       this.page = val;
       this.getData()
    },
    handleTab(idx, id) {
      this.currentTab = idx;
      this.tabId = id;
      this.page = 1
      this.getList();
    },
    goPage(idx) {
        this.$router.push({
          path:'/newDetail',
          query:{
            idx,
            cls:this.currentTab
          }
        });
    },
  },
  components: {
    Footer,
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
  },
};
</script>

<style lang='scss' scoped>
.template {
  // margin-top: 64px;
  background: #f5f5f5;
  .wrap {
    width: 1200px;
    margin: 0 auto;
  }
  .title-area {
    height: 450px;
    background: url("") no-repeat;
    background-size: cover;
    overflow: hidden;
    .top-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 150px;
    }
    .title {
      font-size: 64px;
      font-weight: 600;
      color: #ffffff;
      line-height: 75px;
      margin-bottom: 25px;
    }
    .english-title {
      font-size: 32px;
      font-weight: 400;
      color: #ffffff;
      line-height: 38px;
    }
  }
}
.news-content {
  .tabs-list {
    display: flex;
    margin-bottom: 12px;
    margin-top: 30px;
    .tab-item {
      font-size: 24px;
      font-weight: 500;
      color: #606266;
      line-height: 28px;
      padding: 12px 8px;
      border-bottom: 4px solid transparent;
      margin-right: 60px;
      cursor: pointer;
    }
    .active {
      color: #1d7bff;
      border-bottom: 4px solid #1d7bff;
    }
  }
  .news-list {
    margin-bottom: 72px;
    .news-item {
      display: flex;
      padding: 24px 0;
      border-bottom: 1px solid #e5e6eb;
      cursor: pointer;
      .news-img {
        width: 254px;
        height: 195px;
        margin-right: 20px;
        img {
          width: 254px;
          height: 195px;
        }
      }
      .news-info {
        .news-title {
          font-size: 28px;
          font-weight: 400;
          color: #202020;
          line-height: 33px;
          margin-bottom: 12px;
        }
        .news-detail {
          font-size: 14px;
          color: #606266;
          line-height: 20px;
          margin-bottom: 25px;
          overflow: hidden;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .time {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
          margin-bottom: 50px;
        }
        .more {
          font-size: 14px;
          color: #1d7bff;
          line-height: 16px;
          img {
            width: 18px;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .pages {
    margin-bottom: 88px;
    text-align: center;
  }
}
</style>